import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TarifaDetallesService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getTarifaByTarifaId(id: number) {
    return this.http.get(this.myAppUrl + 'api/TarifaDetalle/GetByTarifaId/' + id);
  }

  getTarifaById(id: number) {
    return this.http.get(this.myAppUrl + 'api/TarifaDetalle/GetById/' + id);
  }

  createTarifaDetalle(detalle: any) {
    return this.http.put(this.myAppUrl + 'api/TarifaDetalle', detalle);
  }

  updateTarifaDetalle(detalle: any) {
    return this.http.post(this.myAppUrl + 'api/TarifaDetalle', detalle);
  }

  deleteTarifaDetalle(id: number) {
    return this.http.delete(this.myAppUrl + 'api/TarifaDetalle/' + id);
  }
}
